import tradingFlow from './tradingFlow.vue'

export default tradingFlow
